import React from 'react'
import FloatingActionButton from 'material-ui-legacy/FloatingActionButton'
import ContentAdd from 'material-ui-legacy/svg-icons/content/add'
import {grey900} from 'material-ui-legacy/styles/colors'

const SmallAddButton = (props) => (
  <FloatingActionButton backgroundColor='#fff' mini {...props}>
    <ContentAdd style={{fill: grey900}} color={grey900} />
  </FloatingActionButton>
)

export default SmallAddButton



// WEBPACK FOOTER //
// ./src/components/UI/SmallAddButton.jsx